exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popover.log-popover{display:none!important}@media screen and (min-width:960px){.popover.log-popover{display:block!important;width:80vw;max-width:80vw!important;height:250px!important;max-height:250px!important}.popover.log-popover .table-responsive{overflow-x:hidden;overflow-y:auto;max-height:200px}}@media screen and (min-width:1200px){.popover.log-popover{width:50vw}}", ""]);

// exports
